import React from 'react';
import Table from '../../components/subcomponents/table';
import Button from '../../components/subcomponents/controls/button';
import FormHeader from '../../components/subcomponents/formheader';
import { connect } from 'react-redux';
import module from '../../api/module';
import module_component from '../../api/module_component';
import TableControl from '../../components/subcomponents/table_control';
import notification from '../../components/subcomponents/notification';
import SubformDetails from '../../components/subcomponents/subform_details';

class moduleList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            hide_details: false
        }
    }
    componentWillMount() {
        module.list();
        this.props.handleSelect(false);
    }
    selectModule(id) {
        let self = this;
        if (id) {
            this.setState({hide_details: true});
            this.props.handleSelect(id);
            module_component.linked_list(function(error,response) {
                if (error) notification.error(error.message);
                self.setState({hide_details: false});
            });
        } else {
            this.props.handleSelect(id);
        }
    }
    handleNew() {
        this.props.handleSelect(false);
        this.props.history.push('/module/add');
    }
    handleEdit() {
        this.props.history.push('/module/update');
    }
    handleDelete() {
        module.del(()=>{
            module.list();
        });
    }
    showComponentList() {
        if (this.props.module_selected && this.props.module_component_list.length) {
            return (
                <SubformDetails is_hidden={this.state.hide_details} title="Module components" className="details width_100">
                    <Table name="module_component_list" table_key={'class_prop'}
                        headers={{ 
                         class_prop: {label: 'Name',width: '15%'}, 
                         component_class: {label: 'Class', width: '15%'},
                         controller_name: {label: 'Controller', width: '25%'}, 
                         component_name: {label: 'Connector', width: '15%'},
                         component_id: {label: 'ID', width: '10%'},
                         disabled: {label: 'Disabled', width: '10%'}
                         }}
                        data={this.props.module_component_list}/>
                </SubformDetails>)
        }
    }
    render() {
        return (
            <div className="form_wrap module_list">
                <FormHeader title='MODULE LIST'/>
                <TableControl search={this.props.search_string} handleSearch={this.props.handleSearch}/>
                <Table name="module_list" selected={this.props.module_selected} handleSelect={this.selectModule.bind(this)} table_key={'module_id'}
                       col_width={{
                           module_name: '50%',
                           module_description: '50%'
                       }}
                       headers={{
                           module_name: {label: 'Name'},
                           module_description: {label: 'Description'}}} data={this.props.module_list}/>
                <div className="toolbar">
                    <Button name="new" label="New" onClick={this.handleNew.bind(this)}/>
                    <Button name="edit" label="Edit" onClick={this.handleEdit.bind(this)} status={this.props.module_del_edit_btn}/>
                    <Button name="delete" label="Delete" onClick={this.handleDelete.bind(this)} status={this.props.module_del_edit_btn}/>
                </div>
                {this.showComponentList()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    let search_string = state.moduleR.search_string;
    let module = state.moduleR.module;
    let module_component = state.moduleR.module_component;
    return {
        search_string: search_string,
        module_list: module.list,
        module_del_edit_btn: (module.selected) ? 'enabled' : 'disabled',
        module_selected: module.selected,
        module_component_list: module_component.list
    };
}

function mapDispatchToProps(dispatch) {
    return({
        handleSearch(result) {
            dispatch({
                type: 'MODULE_DESELECTED'
            });
            dispatch({
                type: "MODULE_UPDATE_SEARCH_STRING",
                value: result.value
            });
            module.list();
        },
        handleSelect(id) {
            if (id) {
                dispatch({
                    type: 'MODULE_SELECTED',
                    value: id
                });
            } else {
                dispatch({
                    type: 'MODULE_DESELECTED'
                })
            }

        }
    })
}

export default moduleList = connect(
    mapStateToProps, mapDispatchToProps)(
    moduleList
);